import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[appProfileHost]' })
export class TabDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}